import { Component, computed, ElementRef, inject, input, signal, viewChild } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { IconComponent } from '@app/shared/components/icon/icon.component';
import { NavItemHoverMenuComponent } from './nav-item-hover-menu/nav-item-hover-menu.component';
import { NavItem } from './nav-item.model';
import { Store } from '@ngrx/store';
import { processHorizonRedirect } from '@app/modules/authentication/store/auth/auth.actions';

@Component({
  selector: 'topo-nav-item',
  imports: [IconComponent, RouterLink, RouterLinkActive, TranslatePipe, NavItemHoverMenuComponent],
  templateUrl: './nav-item.component.html',
  styleUrl: './nav-item.component.scss',
})
export class NavItemComponent {
  navItem = input.required<NavItem>();
  isSideNavExpanded = input.required<boolean>();

  private router = inject(Router);

  navExpandedControl = viewChild<ElementRef<HTMLInputElement>>('navExpanded');

  private store = inject(Store);
  handleClick(item: NavItem): void {
    if (item.id === 'horizon_sso') {
      this.store.dispatch(processHorizonRedirect());
      return;
    }

    if (item.children?.length) {
      if (this.isSideNavExpanded()) {
        const expansionInput = this.navExpandedControl()?.nativeElement;
        const isExpanded = expansionInput?.value === 'expanded';
        expansionInput.value = isExpanded ? 'collapsed' : 'expanded';
      }
    } else {
      this.router.navigate([item.route]);
    }
  }

  activeChildRoutesMap = signal<Record<string, boolean>>({});

  isParentActive = computed(() => {
    const childRouteIsActiveMap = this.activeChildRoutesMap();
    return Object.values(childRouteIsActiveMap).some(isActive => isActive);
  });

  handleIsActiveChange(id: string, isActive: boolean): void {
    this.activeChildRoutesMap.update(state => ({
      ...state,
      [id]: isActive
    }));
  }
}
